import { render, staticRenderFns } from "./driverManagement.vue?vue&type=template&id=c4a00400&"
import script from "./driverManagement.vue?vue&type=script&lang=js&"
export * from "./driverManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports